import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const archivedProjectsDirectoryRoute: InvariantJiraRoute = {
	name: 'archived-projects-directory',
	path: '/jira/settings/projects/archive',
	exact: true,
};
